// frontend/src/services/userService.js
import axios from '../axiosConfig';

/**
 * User Service
 * Handles user-related API calls
 */
export const userService = {
  /**
   * Get all users with 'user' role in entity
   * Used for admin booking creation user selection
   *
   * @param {number} entityId - Entity ID
   * @param {object} params - Query parameters (search, limit)
   * @returns {Promise} API response with user list
   */
  async getEntityUsers(entityId, params = {}) {
    const response = await axios.get(`/api/users/entity/${entityId}/users`, {
      params
    });
    return response.data;
  },

  /**
   * Search users by name/email/phone
   *
   * @param {number} entityId - Entity ID
   * @param {string} searchTerm - Search query
   * @returns {Promise} API response with filtered users
   */
  async searchUsers(entityId, searchTerm) {
    const response = await axios.get(`/api/users/entity/${entityId}/users`, {
      params: { search: searchTerm, limit: 20 }
    });
    return response.data;
  },

  /**
   * Get user by ID (for pre-filling contact info)
   *
   * @param {number} userId - User ID
   * @returns {Promise} API response with user details
   */
  async getUserById(userId) {
    const response = await axios.get(`/api/users/${userId}`);
    return response.data;
  },
};

export default userService;
